import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';

interface MyAnalysis {
  id: number;
  query: string;
  deep_mode: boolean;
}

const getMyAnalyses = async (): Promise<MyAnalysis[]> => {
  const response = await instance.get('/nexa/analysis-templates/my');
  return response.data;
};

export const useGetMyAnalyses = () => {
  return useQuery({
    queryKey: ['my-analyses'],
    queryFn: getMyAnalyses,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
